var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_51413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3677 0.011229C15.31 0.00379018 15.2515 0 15.1927 0C14.8459 0 14.5134 0.131511 14.2682 0.365601L5.23506 8.98169L2.23177 6.11416C1.9866 5.88007 1.65407 5.74856 1.30734 5.74856C0.960612 5.74856 0.628085 5.88007 0.382911 6.11416C0.137737 6.34825 0 6.66575 0 6.9968C0 7.00785 0.000153569 7.01889 0.000460111 7.02991C0.000153805 7.03961 0 7.04933 0 7.05906C0 7.184 0.0253979 7.30773 0.0747431 7.42317C0.0842206 7.44534 0.0945458 7.46712 0.10569 7.48847C0.171187 7.6344 0.265262 7.76711 0.382911 7.87944L4.2697 11.5905L4.40421 11.7209C4.6129 11.9231 4.89135 12.0154 5.16376 11.9979C5.523 12.0178 5.88915 11.8965 6.16406 11.634L16.1171 2.13088C16.3623 1.89679 16.5 1.57929 16.5 1.24824C16.5 1.19515 16.4965 1.1424 16.4895 1.09029C16.4965 1.0446 16.5 0.998209 16.5 0.951468C16.5 0.699123 16.3966 0.457113 16.2124 0.278679C16.0283 0.100244 15.7785 0 15.5181 0C15.4674 0 15.4171 0.00379719 15.3677 0.011229Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8823f6cb8e2d911fd0a74210f1ba624c.svg";
export { ForwardRef as ReactComponent };